import { Injectable } from '@angular/core';
import envConfig from "./../../config/environment-variable-config.json";

@Injectable({
	providedIn: 'root'
})
export class AppInitService {
	

	public async loadConfiguration() {
		const configData: any = envConfig;
		window.environmentVariableConfig = configData;
	}
}
